import compute from 'components/Compute';
$(() => {
  if ($('#addressage_form').length) {
    compute();

    // Custom error message for hidden required file input
    $('#addressage_form').on('submit', function (e) {
      var $frontDelivery = $('input[name=front-delivery]');
      var $frontDeliveryFile = $('input[name=front-delivery-file]');
      var $existingFrontDeliveryFile = $('input[name=existing_front_delivery_file]');
      var $fileLabel = $frontDeliveryFile.closest('label');
      // Remove previous error
      $fileLabel.find('.file-error').remove();
      if ($frontDelivery.is(':checked') && $frontDeliveryFile.length && !$existingFrontDeliveryFile.length && !$frontDeliveryFile.val()) {
        // Prevent submit and show error
        e.preventDefault();
        $fileLabel.append('<div class="file-error" style="color:red;margin-top:5px;">Veuillez sélectionner un fichier excel.</div>');
        // Optionally scroll to label
        $fileLabel[0].scrollIntoView({behavior: 'smooth', block: 'center'});
        return false;
      }
    });
    $('input[name=back-delivery]')
      .on('change', function () {
        var $backDeliveryAddress = $("input[name='back-delivery-address'], textarea[name='back-delivery-address']");
        if ($(this).is(':checked')) {
          $backDeliveryAddress.removeClass('hidden').addClass('d-block').focus();
          $backDeliveryAddress.prop('required', true);
          $('.versoImage').addClass('hidden');
          $('.versoImage[data-type=addressage]').removeClass('hidden');
          window.prices.addressage_delivery = parseFloat($(this).val());
        } else {
          $backDeliveryAddress.prop('required', false);
          $backDeliveryAddress.addClass('hidden').removeClass('d-block');
          $('#back-delivery-price').text(0);
          $('.versoImage').addClass('hidden');
          $('.versoImage[data-type=no_addressage]').removeClass('hidden');
          window.prices.addressage_delivery = 0.0;
        }
        compute();
      })
      .trigger('change');

    $('input[name=front-delivery]')
      .on('change', function () {

        var $frontDeliveryFile = $('input[name=front-delivery-file]');
        var $existingFrontDeliveryFile = $('input[name=existing_front_delivery_file]');
        if ($(this).is(':checked')) {
          $('.showIfFrontDelivery').removeClass('hidden');
          $('.showIfNoFrontDelivery').addClass('hidden');

          if ($('input[name=back-delivery]').is(':not(:checked)')) {
            $('input[name=back-delivery]').trigger('click');
          }

          $('input[name=back-delivery]').attr('onclick', 'this.checked=!this.checked;');

          $('.rectoImage').addClass('hidden');
          $('.rectoImage[data-type=addressage]').removeClass('hidden');

          window.prices.addressage_delivery = 0.0;
          window.prices.addressage_backdelivery = parseFloat($(this).val());

          // Make front-delivery-file required if no existing_front_delivery_file exists
          // Do not set required on hidden file input; rely on custom validation
          $frontDeliveryFile.prop('required', false);
        } else {
          $('.showIfFrontDelivery').addClass('hidden');
          $('.showIfNoFrontDelivery').removeClass('hidden');

          $('.rectoImage').addClass('hidden');
          $('.rectoImage[data-type=no_addressage]').removeClass('hidden');

          $('.input-type-file-container').addClass('hidden');
          $('.downloadExisting').addClass('hidden');

          $('input[name=back-delivery]').attr('onclick', '');
          if ($('input[name=back-delivery]').is(':checked')) {
            window.prices.addressage_delivery = parseFloat($('input[name=back-delivery]').val());
          }
          window.prices.addressage_backdelivery = 0.0;

          // Not required if not checked
          $frontDeliveryFile.prop('required', false);
        }

        compute();
      })
      .trigger('change');

    $('input[name=front-delivery-file]').on('change', function () {
      console.log('click front-delivery-file');
      console.log($(this).val());
      if ($(this).val()) {
        var splitted = $(this)
          .val()
          .split('\\');
        $('#message_file').html(splitted[splitted.length - 1]);
      }
    });
  }
});
